import { HtmlSerializer, type EditorPlugin } from '@aha-app/aha-editor-v2';
import { ApplicationView, observable } from '@aha-app/mvc';
import React from 'react';

export interface HiddenFormInputOptions {
  name: string;
  format?: 'html' | 'json';
}

function HiddenFormInputPluginFactory(
  options: HiddenFormInputOptions
): EditorPlugin {
  const { name, format = 'html' } = options;

  let serializer: HtmlSerializer;
  let editor;

  const state = observable({
    value: '',
  });

  const HiddenInputComponent: React.FC = () => (
    <input type='hidden' name={name} value={state.value} />
  );

  function serializeEditor() {
    setImmediate(() => {
      if (format === 'html') {
        state.value = serializer.serialize();
      } else if (format === 'json') {
        state.value = JSON.stringify({ children: editor.children });
      }
    });
  }

  return {
    name: 'Hidden form input plugin',
    handlers: {
      onInit(ahaEditor) {
        editor = ahaEditor.editor;
        serializer = new HtmlSerializer(ahaEditor.editor);

        serializeEditor();
      },

      onChange() {
        serializeEditor();
      },
    },
    layoutComponent: {
      location: 'below',
      Component: ApplicationView(HiddenInputComponent),
    },
  };
}

export default HiddenFormInputPluginFactory;
